import { render } from "./ProductImageWithColourSelector.vue?vue&type=template&id=31570b81&scoped=true"
import script from "./ProductImageWithColourSelector.vue?vue&type=script&lang=js"
export * from "./ProductImageWithColourSelector.vue?vue&type=script&lang=js"

import "./ProductImageWithColourSelector.vue?vue&type=style&index=0&id=31570b81&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/src/Microfrontends/devices/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31570b81"]])

export default __exports__